import { useCallback } from "react";

import {
  ProjectIssueFragmentDoc,
  ProjectIssueInput,
  useUpdateProjectIssueMutation,
} from "@/generated/graphql";

export function useUpdateProjectIssue(groupId: string) {
  const [updateProjectIssue] = useUpdateProjectIssueMutation({
    update: (cache, { data }) => {
      const updatedIssues = data?.updateProjectIssue ?? [];
      cache.modify({
        fields: {
          projectIssues() {
            return updatedIssues
              .map((i) => {
                return { ...i, groupId };
              })
              .map((issue) =>
                cache.writeFragment({
                  fragment: ProjectIssueFragmentDoc,
                  fragmentName: "ProjectIssue",
                  data: issue,
                })
              );
          },
        },
      });
    },
  });

  return useCallback(
    async (issues: ProjectIssueInput[]) => {
      return updateProjectIssue({
        variables: { input: { groupId, issues } },
      });
    },
    [updateProjectIssue, groupId]
  );
}
